import Paths from '@/common/paths';
import request from '@/utils/request';

import type { FetchTripCategoryResp, TripCategoryDataType } from './trip-category.data';

export async function createTripCategory(params: any) {
  return request.post(Paths.TRIP_CATEGORIES_API, {
    data: params,
  });
}

export async function fetchTripCategories(params?: any): Promise<FetchTripCategoryResp> {
  return request.get(Paths.TRIP_CATEGORIES_API, {
    params,
  });
}

export async function getTripCategoryDetail(id: string): Promise<TripCategoryDataType> {
  return request.get(`${Paths.TRIP_CATEGORIES_API}/${id}`);
}

export async function updateTripCategory(id: string, params: any) {
  return request.patch(`${Paths.TRIP_CATEGORIES_API}/${id}`, {
    data: params,
  });
}

export async function deleteTripCategory(id: string) {
  return request.delete(`${Paths.TRIP_CATEGORIES_API}/${id}`);
}
